<latch-subnav [headerTitle]="headerText"></latch-subnav>
<div class="latch-viewport">
  <latch-card>
    <p latchCardContent>{{ messageText }}</p>
    <ng-container latchCardFooter>
      <button class="latch-button" (click)="handleHome()">Home</button>
      <button class="latch-button" (click)="handleLogout()">Logout</button>
    </ng-container>
  </latch-card>
</div>
